<template>
  <div class="detailed-project-skeleton" aria-busy="true">
    <span class="sr-only">{{ label }}</span>

    <div class="dps-header">
      <div class="dps-header__row">
        <div class="dps-back dps-block dps-shimmer" />
        <div class="dps-header__titles">
          <div class="dps-line dps-line--offer dps-block dps-shimmer" />
          <div class="dps-line dps-line--title dps-block dps-shimmer" />
        </div>
      </div>
    </div>

    <div class="dps-main">
      <div class="dps-main__left">
        <div class="dps-photo dps-block dps-shimmer" />
        <div class="dps-stats dps-block dps-shimmer" />
      </div>
      <div class="dps-main__right dps-block dps-shimmer" />
    </div>

    <div class="dps-tabs dps-block dps-shimmer" />
  </div>
</template>

<script>
export default {
  name: "DetailedProjectSkeleton",
  props: {
    label: {
      type: String,
      default: "Загрузка карточки проекта"
    }
  }
};
</script>

<style lang="scss">
@keyframes detailed-project-skeleton-shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

@mixin detailed-project-skeleton-shimmer-overlay {
  &::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 50%;
    background: linear-gradient(
      90deg,
      rgba(241, 242, 244, 0) 0%,
      rgba(231, 232, 235, 0.9) 50%,
      rgba(241, 242, 244, 0) 100%
    );
    animation: detailed-project-skeleton-shimmer 1.25s ease-in-out infinite;
    pointer-events: none;
  }
}

.detailed-project-skeleton {
  width: 100%;
  box-sizing: border-box;

  .dps-block {
    position: relative;
    overflow: hidden;
    background: #f1f2f4;
    border-radius: 0.8rem;
  }

  .dps-shimmer {
    @include detailed-project-skeleton-shimmer-overlay;
  }

  .dps-header {
    margin: 1rem;

    &__row {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      gap: 1rem;
    }

    &__titles {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
      min-width: 0;
      padding-top: 0.25rem;
    }
  }

  .dps-back {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .dps-line {
    height: 0.85rem;
    border-radius: 0.25rem;

    &--offer {
      width: 8rem;
      max-width: 55%;
    }

    &--title {
      width: 100%;
      height: 1.75rem;
      border-radius: 0.35rem;
    }
  }

  .dps-main {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    margin: 0 1rem 1rem;
    align-items: stretch;

    @media (max-width: 768px) {
      flex-direction: column;
    }
  }

  .dps-main__left {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 59%;
    min-width: 0;

    @media (max-width: 768px) {
      width: 100%;
    }
  }

  .dps-photo {
    width: 100%;
    height: 32.75rem;
    min-height: 14rem;

    @media (max-width: 768px) {
      height: 14rem;
    }
  }

  .dps-stats {
    width: 100%;
    min-height: 6.5rem;
  }

  .dps-main__right {
    width: 40%;
    min-height: 18rem;
    flex: 1;

    @media (max-width: 768px) {
      width: 100%;
      min-height: 14rem;
    }
  }

  .dps-tabs {
    margin: 0 1rem 1rem;
    width: calc(100% - 2rem);
    min-height: 15rem;
    box-sizing: border-box;
  }
}
</style>
